// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************
*  Borders Tokens
******************************/
:root {
  --m-border-radius: 4px;
  --m-border-radius-md: 8px;
  --m-border-radius-xl: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens/_borders.scss"],"names":[],"mappings":"AAAA;;8BAAA;AAGA;EACI,sBAAA;EACH,yBAAA;EACA,0BAAA;AACD","sourcesContent":["/******************************\n*  Borders Tokens\n******************************/\n:root {\n    --m-border-radius: 4px;\n\t--m-border-radius-md: 8px;\n\t--m-border-radius-xl: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
